
import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from './components/ui/theme-provider';
import { AuthProvider } from './context/AuthContext';
import Index from './pages/Index';
import PricingPage from './pages/PricingPage';
import PromptDetailsPage from './pages/PromptDetailsPage';
import CreatePrompt from './pages/CreatePrompt';
import PromptLibraryPage from './pages/PromptLibraryPage';
import UserProfilePage from './pages/UserProfilePage';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import AuthCallback from './pages/AuthCallback';
import NotFound from './pages/NotFound';
import Admin from './pages/Admin';
import EditPromptPage from './pages/EditPromptPage';
import ProductCopilotPage from './pages/ProductCopilotPage';
import ExplorePage from './pages/ExplorePage';
import Dashboard from './pages/Dashboard';
import ResourcesPage from './pages/ResourcesPage';
import { Toaster } from 'sonner';
import AIChatPage from './pages/ai-chat/AIChatPage';

function App() {
  return (
    <QueryClientProvider client={new QueryClient()}>
      <Router>
        <AuthProvider>
          <Toaster />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/explore" element={<ExplorePage />} />
            <Route path="/prompts/:id" element={<PromptDetailsPage />} />
            <Route path="/prompt/:id" element={<Navigate to="/prompts/:id" replace />} />
            <Route path="/profile/:username?" element={<UserProfilePage />} />
            <Route path="/resources" element={<ResourcesPage />} />
            <Route path="/sign-in" element={<SignIn />} />
            <Route path="/signin" element={<Navigate to="/sign-in" replace />} />
            <Route path="/sign-up" element={<SignUp />} />
            <Route path="/signup" element={<Navigate to="/sign-up" replace />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            
            {/* Product Copilot - now points to the enhanced prompt builder */}
            <Route path="/product-copilot" element={<ProductCopilotPage />} />
            
            {/* Admin routes */}
            <Route path="/admin" element={<Admin />} />
            
            {/* AI Chat */}
            <Route path="/ai-chat" element={<AIChatPage />} />
            
            {/* Dashboard */}
            <Route path="/dashboard" element={<Dashboard />} />
            
            {/* Library */}
            <Route path="/library" element={<PromptLibraryPage />} />
            
            {/* Create/Submit */}
            <Route path="/create" element={<CreatePrompt />} />
            <Route path="/submit" element={<Navigate to="/create" replace />} />
            
            {/* Edit prompt */}
            <Route path="/edit-prompt/:promptId" element={<EditPromptPage />} />
            
            {/* Legacy redirects */}
            <Route path="/prompt-builder" element={<Navigate to="/product-copilot" replace />} />
            
            {/* 404 */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AuthProvider>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
